<div #pgDiv>
    <button #prev class="fas fa-chevron-left" id="leftArrow" (click)="previousPg()"></button>
    <span>Página</span>
    <!-- <input #pgInput min="1" [max]="paginationService.allPages" type="number" [value]="paginationService.page" (change)="jumpToPg($event.target.value)">
    <span>de {{ paginationService.allPages }}</span> -->
    <input #pgInput min="1" [max]="getConfig().allPages" type="number" [value]="getConfig().page" (change)="evtJumpToPg($event)">
    <span>de {{ getConfig().allPages }}</span>
    <button #next class="fas fa-chevron-right" id="rightArrow" (click)="nextPg()"></button>
</div>
